module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "header-conten"
  }, [_c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLogin),
      expression: "isLogin"
    }]
  }, _vm._l((_vm.loginList), function(item, index) {
    return _c('li', {
      on: {
        "click": function($event) {
          _vm.setLoginOrRegister(index)
        }
      }
    }, [_vm._v(_vm._s(item))])
  })), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDrop),
      expression: "isDrop"
    }],
    staticClass: "dropdowns"
  }, [_c('el-dropdown', {
    attrs: {
      "trigger": "hover"
    }
  }, [_c('h4', [_c('span', [_vm._v("欢迎你")]), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.name ? _vm.name : _vm.userName)
    }
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', [_c('router-link', {
    attrs: {
      "to": "/setinfo",
      "tag": "p"
    }
  }, [_vm._v("个人设置")])], 1), _vm._v(" "), _c('el-dropdown-item', [_c('router-link', {
    attrs: {
      "to": "/ordermanagement",
      "tag": "p"
    }
  }, [_vm._v("订单管理")])], 1), _vm._v(" "), _c('el-dropdown-item', [_c('router-link', {
    attrs: {
      "to": "/setpassword",
      "tag": "p"
    }
  }, [_vm._v("修改密码")])], 1), _vm._v(" "), _c('el-dropdown-item', [_c('p', {
    on: {
      "click": _vm.setExit
    }
  }, [_vm._v("退出系统")])])], 1)], 1)], 1), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "router-nav"
  }, [_c('ul', [_c('li', [_c('p', {
    class: _vm.ind == 0 ? 'router-link-exact-active' : '',
    on: {
      "click": function($event) {
        _vm.changeIndex(0)
      }
    }
  }, [_vm._v("在线检测")])]), _vm._v(" "), _c('li', [_c('p', {
    class: _vm.ind == 1 ? 'router-link-exact-active' : '',
    on: {
      "click": function($event) {
        _vm.changeIndex(1)
      }
    }
  }, [_vm._v("我的报告")])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isMark),
      expression: "isMark"
    }],
    staticClass: "mark"
  }, [_c('div', {
    staticClass: "mark-content"
  }, [_c('h3', [_vm._v(_vm._s(_vm.markList.title)), _c('img', {
    staticClass: "guanbi",
    attrs: {
      "src": require("../assets/03.png"),
      "alt": ""
    },
    on: {
      "click": _vm.shutDown
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "myfrom"
  }, [_c('el-form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoginFrorm),
      expression: "isLoginFrorm"
    }],
    ref: "ruleLogin",
    attrs: {
      "model": _vm.ruleLogin,
      "rules": _vm.rules,
      "label-position": "top"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "用户名",
      "prop": "userTel"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "maxlength": 11,
      "placeholder": "请输入手机号",
      "autocomplete": "off"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.getOperation('ruleLogin')
      }
    },
    model: {
      value: (_vm.ruleLogin.userTel),
      callback: function($$v) {
        _vm.$set(_vm.ruleLogin, "userTel", _vm._n($$v))
      },
      expression: "ruleLogin.userTel"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "密码",
      "prop": "userPwd"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": "请输入密码",
      "auto-complete": "off",
      "autocomplete": "off"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.getOperation('ruleLogin')
      }
    },
    model: {
      value: (_vm.ruleLogin.userPwd),
      callback: function($$v) {
        _vm.$set(_vm.ruleLogin, "userPwd", $$v)
      },
      expression: "ruleLogin.userPwd"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "forgotPassword",
    on: {
      "click": function($event) {
        _vm.setLoginOrRegister(2)
      }
    }
  }, [_vm._v("忘记密码")]), _vm._v(" "), _c('el-button', {
    staticClass: "myfrom-buttons",
    on: {
      "click": function($event) {
        _vm.getOperation('ruleLogin')
      }
    }
  }, [_vm._v("登录")])], 1), _vm._v(" "), _c('el-form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isRegForm),
      expression: "isRegForm"
    }],
    ref: "registered",
    attrs: {
      "label-position": "top",
      "model": _vm.registered,
      "rules": _vm.registeredRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "手机号",
      "prop": "userTel"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "maxlength": 11,
      "placeholder": "请输入手机号"
    },
    on: {
      "blur": _vm.regPhone
    },
    model: {
      value: (_vm.registered.userTel),
      callback: function($$v) {
        _vm.$set(_vm.registered, "userTel", _vm._n($$v))
      },
      expression: "registered.userTel"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "密码",
      "prop": "zcuserPwd"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": "请输入密码",
      "auto-complete": "off",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.registered.zcuserPwd),
      callback: function($$v) {
        _vm.$set(_vm.registered, "zcuserPwd", $$v)
      },
      expression: "registered.zcuserPwd"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "reg-text",
    attrs: {
      "label": "验证码",
      "prop": "sendSecond"
    }
  }, [_c('el-input', {
    staticClass: "regCode",
    attrs: {
      "type": "text",
      "placeholder": "请输入验证码",
      "maxlength": 6,
      "auto-complete": "off",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.registered.sendSecond),
      callback: function($$v) {
        _vm.$set(_vm.registered, "sendSecond", $$v)
      },
      expression: "registered.sendSecond"
    }
  }), _vm._v(" "), _c('el-button', {
    staticClass: "but",
    attrs: {
      "disabled": _vm.dis
    },
    on: {
      "click": _vm.getRegCode
    }
  }, [_vm._v("获取验证码"), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isSecond),
      expression: "isSecond"
    }]
  }, [_vm._v(" " + _vm._s(_vm.secondText) + "s")])])], 1), _vm._v(" "), _c('el-button', {
    staticClass: "myfrom-buttons",
    on: {
      "click": function($event) {
        _vm.getOperation('registered')
      }
    }
  }, [_vm._v("注册")])], 1), _vm._v(" "), _c('el-form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isResetPassword),
      expression: "isResetPassword"
    }],
    ref: "setNewPassword",
    attrs: {
      "label-position": "top",
      "model": _vm.setNewPassword,
      "rules": _vm.newPas
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "用户名",
      "prop": "userTel"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "maxlength": 11,
      "auto-complete": "off",
      "placeholder": "手机号"
    },
    on: {
      "blur": _vm.setregPhone
    },
    model: {
      value: (_vm.setNewPassword.userTel),
      callback: function($$v) {
        _vm.$set(_vm.setNewPassword, "userTel", _vm._n($$v))
      },
      expression: "setNewPassword.userTel"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "reg-text",
    attrs: {
      "label": "验证码",
      "prop": "sendSecond"
    }
  }, [_c('el-input', {
    staticClass: "regCode",
    attrs: {
      "type": "text",
      "placeholder": "请输入验证码",
      "maxlength": 6
    },
    model: {
      value: (_vm.setNewPassword.sendSecond),
      callback: function($$v) {
        _vm.$set(_vm.setNewPassword, "sendSecond", $$v)
      },
      expression: "setNewPassword.sendSecond"
    }
  }), _vm._v(" "), _c('el-button', {
    staticClass: "but",
    attrs: {
      "disabled": _vm.disab
    },
    on: {
      "click": _vm.getRegNumber
    }
  }, [_vm._v("获取验证码"), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isSecondT),
      expression: "isSecondT"
    }]
  }, [_vm._v(" " + _vm._s(_vm.secondTextT) + "s")])])], 1), _vm._v(" "), _c('el-button', {
    staticClass: "myfrom-buttons",
    on: {
      "click": function($event) {
        _vm.getOperation('setNewPassword')
      }
    }
  }, [_vm._v("下一步")])], 1), _vm._v(" "), _c('el-form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isNewPassword),
      expression: "isNewPassword"
    }],
    ref: "ruleForm2",
    attrs: {
      "label-position": "top",
      "model": _vm.ruleForm2,
      "rules": _vm.rules2
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "请输入新密码",
      "prop": "pass"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": "请输入密码",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.ruleForm2.pass),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "pass", $$v)
      },
      expression: "ruleForm2.pass"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "请确认登录密码",
      "prop": "checkPass"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": "请输入密码",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.ruleForm2.checkPass),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "checkPass", $$v)
      },
      expression: "ruleForm2.checkPass"
    }
  })], 1), _vm._v(" "), _c('el-button', {
    staticClass: "myfrom-buttons",
    on: {
      "click": function($event) {
        _vm.getOperation('ruleForm2')
      }
    }
  }, [_vm._v("确定")])], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoginFrorm),
      expression: "isLoginFrorm"
    }],
    staticClass: "myfrom-footer",
    on: {
      "click": function($event) {
        _vm.setLoginOrRegister(1)
      }
    }
  }, [_vm._v("立即注册")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoginBack),
      expression: "isLoginBack"
    }],
    staticClass: "myfrom-footer",
    on: {
      "click": function($event) {
        _vm.setLoginOrRegister(0)
      }
    }
  }, [_vm._v("返回登录"), _c('img', {
    attrs: {
      "src": require("../assets/Shape.png"),
      "alt": ""
    }
  })])], 1)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isNull),
      expression: "isNull"
    }],
    staticClass: "nullMark"
  }, [_c('div', {
    staticClass: "null-content"
  }, [_c('h3', [_vm._v("提示"), _c('img', {
    staticClass: "guanbi",
    attrs: {
      "src": require("../assets/03.png"),
      "alt": ""
    },
    on: {
      "click": _vm.shutDown
    }
  })]), _vm._v(" "), _c('div', [_c('img', {
    attrs: {
      "src": require("../assets/duihao.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("登录脑健康检测系统，健康信息立即掌握")]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.goLogin
    }
  }, [_vm._v("立即登录")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('img', {
    attrs: {
      "src": require("../assets/02.png"),
      "alt": ""
    }
  }), _vm._v("脑功能检测训练系统")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e135a112","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/header.vue
// module id = 773
// module chunks = 1